import React, {useState} from 'react';
import LineChart from '../../../component/Inc/LineChart';
import 'contents/assets/scss/page/mypage.scss';
import ImgProfile from 'contents/assets/img/@profile.png';
import PopSaleGoal from '../_PopSaleGoal';
import PopChatting from '../_PopChatting';
function Employee() {
  const [modalChattingOpen, setModalChattingOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const lineChartWidth = '100%';
  const lineChartHeight = '140px';
  const labels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  const data = {
    lineChartlabels: labels,
    datasets: [
      {
        label: '목표',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '매출',
        data: [20000, 50000, 30000, 10000, 10000, 20000, 20000, 20000, 60000, 50000, 40000, 20000, 60000, 40000],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      }
    ]
  };
  return (
    <main className="com_container com_teacher">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_1">김직원103 (교무부 / 배정팀)</h2>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box box-2">
            <div className="detail_tit dot">수업등록 요청</div>
            <div className="com_status_box">
              <div className="item">
                <p className="tit">담당 학생</p>
                <p className="num">4030</p>
              </div>
              <div className="item">
                <p className="tit">진행 수업 / 타임 수</p>
                <p className="num">7800 / 9004</p>
              </div>
              <div className="item blue">
                <p className="tit">12월 매출</p>
                <p className="num">785,056</p>
              </div>
              <div className="item">
                <p className="tit">
                  12월 목표 매출
                  <button onClick={() => setModalOpen(true)} className="com_btn xxs gray">
                    수정
                  </button>
                </p>
                <p className="num">840,000</p>
              </div>
            </div>
            <div className="detail_tit dot">월간 평균 매출</div>

            <div className="com_chart_wrap border_none">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="chart_item">
                    <span className="chart_name_label">목표</span>
                    <div className="chart_box chart_blue"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">실매출</span>
                    <div className="chart_box chart_orange"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={data} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
          </section>
          {/* 시범강의 수업 요청 */}
          <section className="box box-1">
            <div className="detail_tit dot">수업 등록</div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="14%" />
                  <col width="14%" />
                  <col width="14%" />
                  <col width="14%" />
                  <col width="14%" />
                  <col width="14%" />
                  <col width="14%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>과목수</th>
                    <th>배정중</th>
                    <th>준비중</th>
                    <th>첫수업</th>
                    <th>진행중</th>
                    <th>보류중</th>
                    <th>타임수</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>국어 345</td>
                        <td>65</td>
                        <td>23</td>
                        <td className="td_red">33</td>
                        <td>23</td>
                        <td>23</td>
                        <td>523</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
          {/* 받은 메일 */}
          <section className="box box-2 sec_received_mail">
            <div className="detail_tit dot">
              받은 메일
              <button className="com_btn orange xs btn_mail_send">메일 보내기</button>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="25%" />
                  <col width="25%" />
                  <col width="50%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>보낸사람</th>
                    <th>날짜</th>
                    <th>메일 제목</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>
                          <button className="name btn_link">김등록111</button>
                        </td>
                        <td className="td_date">2022.08.25</td>
                        <td className="td_left">
                          <p className="memo">안녕하세요 금일 일정이 있습니다</p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
          {/* 채팅 목록 */}
          <section className="box box-1">
            <div className="detail_tit dot">채팅 목록</div>
            <ul className="chat_list">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                return (
                  <li onClick={() => setModalChattingOpen(true)} className="item" key={idx}>
                    <p className="thumb">
                      <img src={ImgProfile} alt="profile" />
                    </p>
                    <div className="info_box">
                      <p className="name">홍길동103 (영어)</p>
                      <p className="desc">안녕하세요 궁금한게 있습니다......!!!!!</p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </section>
        </section>
      </div>
      <PopSaleGoal open={modalOpen} close={() => setModalOpen(false)} />
      <PopChatting open={modalChattingOpen} close={() => setModalChattingOpen(false)} />
    </main>
  );
}

export default Employee;
